import { StepSchema } from '@feedyou/schema'
import { STABLE_EMPTY_ARRAY, STABLE_EMPTY_OBJECT } from '@feedyou/utils'

import { StepService } from '../../types'

export function createStepService<Step extends StepSchema, Substeps extends object>(
  definitions: Partial<StepService<Step, Substeps>>
): StepService<Step, Substeps> {
  return { ...getEmptyDefaults<Step, Substeps>(), ...definitions }
}

function getEmptyDefaults<Step extends StepSchema, Substeps extends object>(): StepService<
  Step,
  Substeps
> {
  return {
    getUsedDialogs: () => STABLE_EMPTY_ARRAY,
    unsetDialogs: (dialogIds: string[], step: Step) => step,
    getSubdialogConnectionsMetadata: () => STABLE_EMPTY_ARRAY,

    search: () => STABLE_EMPTY_ARRAY,

    useFormSchema: () => STABLE_EMPTY_OBJECT,
    useFormUiSchema: () => STABLE_EMPTY_OBJECT,
    useAdjustedFormData: () => (formData, schema) => formData,

    // @ts-ignore
    substeps: {}
  }
}
